"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayWrappersType = void 0;
const tsenum_1 = require("@gradecam/tsenum");
exports.StringArrayWrappersType = tsenum_1.MakeEnum({
    Variable: 'variable',
    Function: 'function',
});
